
export const navStudentItems = [
  {
    title: 'Dashboard',
    icon: 'la-home',
    page: '/student/dashboard',

  },
  { section: 'APPS', icon: 'la-ellipsis-h' },
  {
    title: 'ผลการเรียน',
    icon: 'la-calendar-check-o',
    page: '/student/grade'
  },
  {
    title: 'ตารางเรียน',
    icon: 'la la-table',
    page: '/student/timetable'
  },
  {
    title: 'การบ้าน',
    icon: 'fa-pencil-square-o',
    page: '/student/homework'

  },
  {
    title: 'ความประพฤติ',
    icon: 'la-users',
    page: '/student/report-score'
  },
  {
    title: 'SDQ',
    icon: 'la-users',
    page: '/student/SDQ-std'
  },
  {
    title: 'การสแกนบัตร',
    icon: 'fa-check',
    page: '/student/report-scan'
  },
  // {
  //   title: 'เอกสารคำร้อง',
  //   icon: 'la la-file-text',
  //   page: 'null',
  //   submenu: {
  //     items: [
  //       {
  //         title: 'ใบรับรองความประพฤติ',
  //         icon: 'la-arrow-circle-right',
  //         page: '/student/document/conduct',
  //         id: ''
  //       },
  //       {
  //         title: 'ใบลานักเรียน',
  //         icon: 'la-arrow-circle-right',
  //         page: '/student/document/leave',
  //         id: ''
  //       },
  //       {
  //         title: 'ใบขออนุญาตออกนอกโรงเรียน',
  //         icon: 'la-arrow-circle-right',
  //         page: '/student/document/out-school',
  //         id: ''
  //       }
  //     ]
  //   }
  // },
  // {
  //   title: 'เปลี่ยนรหัสผ่าน',
  //   icon: 'fa-check',
  //   page: '/student/report-scan'
  // },
];